import { render, staticRenderFns } from "./PT462ItemReviewListParts.vue?vue&type=template&id=086173ec&scoped=true&"
import script from "./PT462ItemReviewListParts.vue?vue&type=script&lang=js&"
export * from "./PT462ItemReviewListParts.vue?vue&type=script&lang=js&"
import style0 from "./PT462ItemReviewListParts.vue?vue&type=style&index=0&id=086173ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086173ec",
  null
  
)

export default component.exports